import React, { useCallback, useEffect, useState } from "react"
import { Paper, TableCell, TableRow } from "@material-ui/core"
import {
  DatatablesFooterServerSide,
  Title,
  TableCellDefault,
  ModalDeleteConfirm,
  Loading,
  TableAction,
} from "App/Component/ui"

import {
  FormKunjunganRawatInap,
  headCells,
  STYLE_MASTER_GUDANG_UTAMA,
  RESET_STATE_KUNJUNGAN_RAWAT_INAP,
  FormFilterKunjunganRawatInap,
  RESET_STATE_FORM_FILTER,
  getByFilterKunjunganRawatInap,
  deleteKunjunganRawatInapById,
  getDataSelectRekamMedis,
} from "./ui"

import { useDatatables, useDatatablesServerSide } from "App/hooks"
import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  isNull,
  scrollToTop,
  today,
} from "App/utils/helpers"
import { ModalKunjunganBaru } from "../KunjunganRawatJalan/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import {
  CountHarian,
  getCaraMasuk,
  prefixNoRM,
  StatusKunjungan,
  StatusRaber,
} from "../utils"
import { LIST_URL_REGISTRASI } from "utils/registrations"
import { FreezeTable } from "components/organism"
import { useSelector } from "react-redux"
import useCOB from "../ui/COB/useCOB"

export default function KunjunganRawatInap() {
  const classes = STYLE_MASTER_GUDANG_UTAMA()
  const [showModalKunjunganBaru, setShowModalKunjunganBaru] = useState(false)
  const master = useSelector(({ master }) => master)
  const kelas = master.kelas_kamar.list_select
  const [rows, setRows] = useState([])

  const { rowsCOB, setRowsCOB, setNewDataCOB, loadingCOB } = useCOB()

  const [formData, setFormData] = useState({
    ...RESET_STATE_KUNJUNGAN_RAWAT_INAP,
    filter_kelas_id: kelas[0].value,
  })
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER)
  const [totalData, setTotalData] = useState(0)
  const [loading, setLoading] = useState(false)
  const [registrationId, setRegistrationId] = useState("")

  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const countHarian = CountHarian(
    LIST_URL_REGISTRASI.kunjungan_rawat_inap.count,
  )

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
  ) => {
    setLoading(true)

    const res = await getByFilterKunjunganRawatInap(formFilter, pages, limit)
    if (res.state) {
      setRows(res.data)
      setTotalData(res.meta.count)
      setLoading(false)
    } else {
      setRows([])
      setLoading(false)
      defaultToastError(res.message)
    }
  }

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = useDatatablesServerSide({ setNewData: setNewData })

  const handleClickButtonKunjunganBaru = () => {
    setShowModalKunjunganBaru(!showModalKunjunganBaru)
  }

  const handleClickSelect = (row) => {
    const selectRekamMedis = getDataSelectRekamMedis(row)
    setFormData({
      ...RESET_STATE_KUNJUNGAN_RAWAT_INAP,
      ...selectRekamMedis,
      date: today(true),
    })
    setShowModalKunjunganBaru(false)
  }

  const handleClickUpdate = async (row) => {
    setLoading(true)
    if (row.cobs) {
      const cobData = await setNewDataCOB(row.id)

      setRowsCOB(cobData)
      setFormData({ ...formData, cob: true })
    }

    setRegistrationId(row.id)
    setFormData({
      ...formData,
      nama_rm: row?.rm_name,
      umur: row?.umur,
      nik: row?.nik,
      tanggal_selesai: row?.tanggal_selesai,

      jenis_layanan_id: row?.jenis_layanan_id,
      kelaskunjungan_id: row?.kelaskunjungan_id,
      kelaskunjungan: row?.kelaskunjungan,
      doctor_id: row?.doctor_id,
      spec_id: row?.spesialist_id,
      spec_code: row?.spesialist_code,
      norm: prefixNoRM(row.patients_id),
      penanggung: row?.rm_guarantor_name,
      pekerjaan: row?.rm_occupation_name,

      gender: row?.rm_gender === 1 ? "Laki-Laki" : "Perempuan",
      gender_print: row.rm_gender,
      patients_id: row?.patients_id,
      date: defaultDateInputDisplay(row?.date, true),

      nohp: row?.nohp,
      phone_number: row?.rm_phone_number,
      address_now: row?.rm_address_now,

      company_id: row?.company_id,
      company_name: row?.company_name,

      insurance_id: row?.insurance_id,
      insurance_name: row?.insurance_name,

      insurance_no: row?.insurance_no,
      norujukan: row?.norujukan,
      status: row?.status,

      filter_kelas_id: row?.bed_kelas_id,
      bed_id: row?.bed_id,
      label_bed: row?.bed_name,
      kelas_bed: row?.bed_kelas_name,

      rencana_pulang: isNull(row?.tanggal_rencana_pulang)
        ? ""
        : defaultDateInputDisplay(row?.tanggal_rencana_pulang, true),

      insurance_type_name: row?.insurance_type_name,
      doctor_name: row?.doctor_fullname??"",
      isexternalrm: false,
      date_ob: row?.rm_date_ob,
      typeofcare_code: "RINAP",

      no_sep: isNull(row.no_sep) ? "" : row.no_sep,
      remark: row.remark,

      cob: row.cobs,

      cara_masuk: row.cara_masuk,
      cara_masuk_name: getCaraMasuk(row.cara_masuk)?.cara_masuk_name,
      is_rawat_bersama: row?.is_rawat_bersama,
    })

    scrollToTop()
    setLoading(false)
  }

  const handleKeyPress = useCallback((event) => {
    if (event.key === "F4") {
      setShowModalKunjunganBaru(true)
    }

    if (event.key === "F6") {
      setRegistrationId(null)
      setFormData(RESET_STATE_KUNJUNGAN_RAWAT_INAP)
    }
  }, [])

  React.useEffect(() => {
    document.addEventListener("keydown", handleKeyPress)
    return () => {
      document.removeEventListener("keydown", handleKeyPress)
    }
  }, [handleKeyPress])

  return (
    <div className={classes.root}>
      {showModalKunjunganBaru && (
        <ModalKunjunganBaru
          formData={formData}
          setFormData={setFormData}
          onlyInternal={true}
          handleClickSelect={handleClickSelect}
          setShowModal={() => setShowModalKunjunganBaru(false)}
        />
      )}

      <Title title="Kunjungan Rawat Inap" />

      <FormKunjunganRawatInap
        formData={formData}
        setFormData={setFormData}
        setRows={setRows}
        setNewData={setNewData}
        registrationId={registrationId}
        setRegistrationId={setRegistrationId}
        pagination={pagination}
        handleClickButtonKunjunganBaru={handleClickButtonKunjunganBaru}
        rowsCOB={rowsCOB}
        setRowsCOB={setRowsCOB}
      />

      <div className="mt-2">
        <Paper className={classes.paper}>
          <FormFilterKunjunganRawatInap
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewData}
            countHarian={countHarian}
            withExportButton={true}
            resetPagination={resetPagination}
          />

          <Loading show={loading} />
          <TableRawatInap
            rows={rows}
            setNewData={setNewData}
            handleClickUpdate={handleClickUpdate}
          />

          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>

      <ul
        style={{
          fontSize: "11px",
          marginTop: "2rem",
          padding: "1rem",
        }}
      >
        <li>Gunakan F2 untuk memunculkan modal SPRI</li>
        <li>Gunakan F4 untuk memunculkan modal kunjungan baru </li>
        <li>Gunakan F6 untuk untuk reset form</li>
      </ul>
    </div>
  )
}

const TableRawatInap = ({ rows, handleClickUpdate, setNewData }) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "date",
    orderByRow: ["id", "date"],
  })
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [registrationId, setRegistrationId] = useState("")

  async function deleteList() {
    const res = await deleteKunjunganRawatInapById(registrationId)

    if (res.state) {
      defaultToastSuccess(res.message)
      await setNewData(1, 10)
    } else {
      defaultToastError(res.message)
    }

    setShowModalDeleteConfirm(false)
  }

  function handleClickDelete(row) {
    setRegistrationId(row.id)
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <FreezeTable
        headCells={headCells}
        handleRequestSort={handleRequestSort}
        order={order}
        length={length}
        orderBy={orderBy}
      >
        {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
          return (
            <TableRow hover key={index}>
              <TableCell align="center">{index + 1}</TableCell>

              <TableCell align="center">
                <TableAction
                  clickDelete={() => handleClickDelete(row)}
                  clickUpdate={() => handleClickUpdate(row)}
                />
              </TableCell>
              <TableCell align="left">{row?.id}</TableCell>
              <TableCell align="left">{row?.patients_id}</TableCell>
              <TableCell align="left">{row?.rm_name}</TableCell>
              <TableCell align="left">{row?.tagihan_id}</TableCell>
              <TableCell align="left">{row?.nama_kelas_kunjungan}</TableCell>
              <TableCell align="left">
                {defaultDateDisplay(row?.date, true)}
              </TableCell>
              <TableCell align="left">
                {defaultDateDisplay(row?.tanggal_selesai, true)}
              </TableCell>
              <TableCell align="left">
                <StatusKunjungan status={row.status} iscancel={row.iscancel} />
              </TableCell>
              <TableCell align="center">
                <StatusRaber status={row.is_rawat_bersama} />
              </TableCell>
              <TableCell align="left">{row?.nohp}</TableCell>
              <TableCell align="left">{row?.rm_phone_number}</TableCell>
              <TableCell align="left">{row?.doctor_fullname}</TableCell>
              <TableCell align="left">{row?.company_name}</TableCell>
              <TableCell align="left">{row?.insurance_name}</TableCell>
              <TableCell align="left">{row?.insurance_no}</TableCell>
              <TableCell align="left">{row?.no_sep}</TableCell>
              <TableCell align="left">
                {defaultDateDisplay(row?.rm_date_ob, false)}
              </TableCell>
              <TableCell align="left">{row?.umur}</TableCell>
              <TableCell align="left">{row?.bed_name}</TableCell>
              <TableCell align="left">{row?.bed_ruang_name}</TableCell>
              <TableCell align="left"> {row.nama_ppk_perujuk}</TableCell>
              <TableCell align="left">{row?.nama_hak_kelas}</TableCell>
              <TableCell align="left">{row?.remark}</TableCell>
              <TableCellDefault row={row} />
            </TableRow>
          )
        })}
        {rows.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={headCells.length}>
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </FreezeTable>
    </>
  )
}
